import {withYoutubeApi, withVimeoApi} from "../../define/shared";

export default function initSplitBlocks() {
    const blocks = [].slice.call(document.querySelectorAll('.splitBlock.mediaType-video'));

    blocks.forEach(initSplitBlock);
}

function initSplitBlock(root) {
    const playButton = root.querySelector('.playButton');
    const videoModal = root.querySelector('.videoModal');

    if (!videoModal) {
        return;
    }

    const videoIframe = videoModal.querySelector('.videoModal-inner');
    const closeButton = videoModal.querySelector('.closeButton');
    const videoId = videoModal.dataset.id;
    const videoProvider = videoModal.dataset.provider;
    let player = null;

    playButton.addEventListener('click', openModal);
    closeButton.addEventListener('click', closeModal);

    function initPlayer() {
        if (videoProvider === 'vimeo') {
            withVimeoApi((vimeo) => {
                player = new Vimeo.Player(videoIframe, {
                    id: videoId,
                })

                player.on('loaded', () => {
                    player.play()
                })
            })
        } else if (videoProvider === 'youtube') {
            withYoutubeApi((youtube) => {
                if (!player) {
                    player = new youtube.Player(videoIframe, {
                        videoId: videoId,
                        playerVars: {

                        },
                        events: {
                            onReady: () => {
                                player.playVideo();
                            }
                        },
                    });
                }
            })
        }
    }

    function openModal() {
        videoModal.style.display = 'block';

        initPlayer();

        closeButton.focus();
    }

    function closeModal() {
        videoModal.style.display = 'none';

        videoProvider === 'vimeo' ? player.pause() : player.pauseVideo();
    }
}
